import { render, staticRenderFns } from "./newsletter-form.vue?vue&type=template&id=35d2d100&scoped=true&"
import script from "./newsletter-form.vue?vue&type=script&lang=ts&"
export * from "./newsletter-form.vue?vue&type=script&lang=ts&"
import style0 from "./newsletter-form.vue?vue&type=style&index=0&id=35d2d100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2d100",
  null
  
)

export default component.exports